export class I18nextAsyncBackend {
  type = 'backend'
  init() {}
  read(language, namespace, callback) {
    const filename = `${namespace}-${language}`
    import('c1-i18n/dist/' + filename + '.json')
      .then(translation => callback(null, translation))
      .catch(error => callback(error))
  }
}
